/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { apiKeysDelete } from "../../funcs/apiKeysDelete.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .DeleteApiLeadScraperMicroserviceApiV1ApiKeysKeyIdRequest$inboundSchema,
};

export const tool$apiKeysDelete: ToolDefinition<typeof args> = {
  name: "api-keys_delete",
  description: `Delete API key

Permanently deletes an API key`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await apiKeysDelete(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
